/* Helpers to build context-aware WhatsApp / Telegram deep links. */

export function buildWhatsAppLink(number, text) {
  const n = (number || "").replace(/[^0-9]/g, "");
  if (!n) return "";
  const t = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${n}${t}`;
}

export function buildTelegramLink(username) {
  const u = (username || "").replace(/^@/, "").trim();
  if (!u) return "";
  return `https://t.me/${u}`;
}

export function buildPhoneLink(phone) {
  const p = (phone || "").replace(/[^0-9+]/g, "");
  if (!p) return "";
  return `tel:${p}`;
}

export function buildEmailLink(email, subject, body) {
  const e = (email || "").trim();
  if (!e) return "";
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${e}${params.length ? `?${params.join("&")}` : ""}`;
}

/* A friendly default message used by the floating widget. */
export function defaultEnquiryMessage() {
  return `Hello! I'm interested in renting a luxury villa in Marbella. Could you help me?`;
}

/* A rich, prefilled message with the full booking context. */
export function bookingEnquiryMessage(booking, villa) {
  if (!booking) return defaultEnquiryMessage();
  const lines = [
    `Hello! I've just submitted a booking request and would love to confirm the details:`,
    ``,
    `Villa: ${villa?.name || booking.villa_name || ""}`,
    booking.reference ? `Reference: ${booking.reference}` : "",
    booking.check_in && booking.check_out ? `Dates: ${booking.check_in} to ${booking.check_out}` : "",
    booking.guests ? `Guests: ${booking.guests}` : "",
  ].filter(Boolean);
  return lines.join("\n");
}
